import {ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-test-epq-instructions',
    templateUrl: './test-epq-instructions.component.html',
    styleUrls: ['./test-epq-instructions.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TestEpqInstructionsComponent {
    @Output() selected = new EventEmitter<string>();

    nextStep(): void {
        this.selected.next('next');
    }

    previousStep(): void {
        this.selected.next('previous');
    }
}
